export default {
  setUserLanguage: (state, language) => (state.userLanguage = language)
}
